/**
 * Vendors API Client — Landlord Portal
 */

import { z } from 'zod';
import { apiFetch } from '../lib/api';
import { VendorResponseSchema } from '@resida/api-types/vendor';

// Derived from VendorResponseSchema in @resida/api-types/vendor
export type Vendor = z.infer<typeof VendorResponseSchema>;

export interface CreateVendorBody {
  name: string;
  trades: string[];
  phone?: string;
  email?: string;
  notes?: string;
}

export interface UpdateVendorBody {
  name?: string;
  trades?: string[];
  phone?: string | null;
  email?: string | null;
  notes?: string | null;
  isActive?: boolean;
}

export async function listVendors(): Promise<{ vendors: Vendor[] }> {
  return apiFetch('/landlord/api/vendors');
}

export async function createVendor(body: CreateVendorBody): Promise<Vendor> {
  return apiFetch('/landlord/api/vendors', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function updateVendor(
  id: string,
  body: UpdateVendorBody,
): Promise<Vendor> {
  return apiFetch(`/landlord/api/vendors/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export async function deactivateVendor(id: string): Promise<void> {
  await apiFetch(`/landlord/api/vendors/${id}`, {
    method: 'DELETE',
  });
}
